import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getMerchantShippingClaimSummariesByIds = {
  name: "getMerchantShippingClaimSummariesByIds" as const,
  input: z.object({ ids: z.array(z.string()).max(50) }),
  output: z.object({
    summaries: z.array(
      z.object({ _id: zExt.objectId(), submittedAt: z.date() }),
    ),
  }),
};
